<script>
/**
 * ****************************************************************************
 * @description     :   Popup Order006 (受注検索)
 * @created at      :   2026/02/16
 * @created by      :   DaoNX
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupOrder006Store from '@/views/popupSearch/PopupOrder006/store';
import PopupMST005Store from '@/views/popupSearch/PopupMST005/store';
import helpers from '@/utils/helpers';

var PopupOrder006Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupOrder006')) {
            store.registerModule('PopupOrder006', PopupOrder006Store);
        }
        if (!store.hasModule('PopupMST005')) {
            store.registerModule('PopupMST005', PopupMST005Store);
        }
    },
    async created() {
        this.onInitScreen();
        this.applyInitData();
        if (this.data.department_cd) {
            await this.referAreaInfo(0, this.data.department_cd);
        }
        this.loadStatusOptions();
        this.search();
    },
    data() {
        return {
            rowActive: null
        };
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('app', ['user']),
        ...mapState('PopupOrder006', ['data', 'searchData', 'options', 'paginationData'])
    },
    methods: {
        ...mapMutations('PopupOrder006', ['resetDataInit', 'setCombobox']),
        ...mapActions('PopupOrder006', ['actionSearch']),
        ...mapActions('PopupMST005', ['searchAreaInfo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                }
                if (this.initData.department_cd !== undefined) {
                    this.data.department_cd = this.initData.department_cd;
                }
                if (this.initData.department_name !== undefined) {
                    this.data.department_name = this.initData.department_name;
                }
            }
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        search() {
            this.actionSearch({
                body: {
                    ...this.data,
                    page_no: this.paginationData.pageNo,
                    page_size: this.paginationData.pageSize
                },
                callback: () => {
                    this.rowActive = null;
                }
            });
        },
        changeCurrentPage(data) {
            this.actionSearch({
                body: {
                    ...this.data,
                    page_no: data.currentPage,
                    page_size: data.perPage
                },
                callback: () => {
                    this.rowActive = null;
                }
            });
        },
        referAreaInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (value) {
                    this.searchAreaInfo({
                        company_cd: this.data.company_cd ?? 0,
                        department_cd: value,
                        mode: 1,
                        callback: (response) => {
                            if (response.Data.data.length > 0) {
                                const result = response.Data.data[0];
                                this.data.department_cd = result.department_cd;
                                this.data.department_name = result.department_name;
                            } else {
                                this.data.department_cd = '';
                                this.data.department_name = '';
                            }
                            resolve();
                        },
                        onError: (error) => {
                            reject(error);
                        }
                    });
                } else {
                    this.data.department_cd = '';
                    this.data.department_name = '';
                    resolve();
                }
            });
        },
        getAreaName(data) {
            this.data.department_name = data;
        },
        adjustDate(days, fieldName) {
            this.data[fieldName] = helpers.adjustDate(days, this.data[fieldName]);
        },
        chooseItem(item, index) {
            this.rowActive = index;
            this.$emit('onReferModelValue', item.order_no_export);
            this.$emit('onReferValueName', item.billing_name ?? '');
            this.$emit('close');
        },
        async loadStatusOptions() {
            try {
                const companyCd = this.data.company_cd || this.user?.company_cd || '';
                const result = await helpers.getDataSys005({ meisho_cd: 58, company_cd: companyCd });
                const statusOptions = (result || []).map((item) => ({
                    code: item.code ?? '',
                    name: item.name ?? ''
                }));
                this.setCombobox(statusOptions);
            } catch (e) {
                console.log('loadStatusOptions: ' + e.message);
                this.setCombobox([]);
            }
        }
    }
};
export default PopupOrder006Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
@use '@/views/move/mng_order/MNG_Order006/style.scss' as *;
</style>
